<template>
  <b-input-group>
    <b-input
      :value="filter"
      class="form-control userFilter"
      placeholder="Search Users by First Name, Last Name, or Email"
      type="search"
      @change="updateFilter"
      @keydown.esc="clearFilter"
    ></b-input>
    <template #append>
      <b-button variant="primary" :disabled="!filter.trim()" @click="getUsers()"
        >Search Users
      </b-button>
    </template>
  </b-input-group>
</template>
<script>
  export default {
    name: 'filter-users',
    props: {
      perPage: {
        type: Number,
        default: 10,
      },
      filter: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        pageOptions: [5, 10, 15, 20],
      };
    },
    computed: {
      dropdownText() {
        if (window.screen.width < 500) {
          return this.perPage.toString();
        }
        return 'Per page: ' + this.perPage.toString();
      },
    },
    methods: {
      updateFilter(filter) {
        this.$emit('update:filter', filter);
      },
      clearFilter() {
        this.$emit('update:filter', '');
      },
      updatePerPage(option) {
        this.$emit('update:perPage', option);
      },
      getUsers() {
        this.$emit('get-users');
      },
    },
  };
</script>

<style scoped>
  .userFilter {
    background: #f4eff4;
    /* border-radius: 24px; */
  }
</style>
